import React, { Component } from 'react';
import GradientButton from './Button/GradientButton';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            isShowError: false,
        };
    }

    componentDidCatch(error, errorInfo) {
        // Update state with error information
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo,
            isShowError: false,
        });
    }

    handleErrorShow = () => {
        this.setState(prev => ({
            ...prev,
            isShowError: !prev.isShowError,
        }));
    }

    render() {
        if (this.state.hasError) {
            // You can customize the error message or render a fallback UI here
            return (
                <div className='flex flex-col justify-center items-center w-full bg-gray-100'>
                    <h1 className='rounded-lg bg-orange2 text-pureWhite font-semibold text-lg px-6 py-2 mt-5'>Hi, This is Mawhiba Meta Mind Error Detector</h1>
                    <h2 className='my-5 text-lg border-b-2 border-gray-300'>Something went wrong in your project</h2>
                    <GradientButton onClick={this.handleErrorShow}>{this.state.isShowError ? "Hide Error": "Show Error"}</GradientButton>
                    {this.state.isShowError && 
                        <div className='px-6 mt-6 flex flex-col items-center'>
                            <p className='border-2 border-gray-300 rounded-lg flex text-center font-semibold px-6 py-2'>{this.state.error.toString()}</p>
                            <br />
                            <div>{this.state.errorInfo.componentStack}</div>
                        </div>
                    }
                </div>
            );
        }

    // If there's no error, render the child components
    return this.props.children;
  }
}

export default ErrorBoundary;